// https://tanstack.com/router/latest/docs/framework/react/guide/custom-link#react-aria-components-example
import { createLink } from '@tanstack/react-router'
import { composeRenderProps, type LinkProps, Link as RACLink } from 'react-aria-components'
import { ButtonContent, button, type Variants } from './button'

export interface LinkButtonProps extends LinkProps, Variants {
  children?: React.ReactNode
}

function MyLinkButton({
  className,
  variant = button.defaultVariants.variant,
  flex,
  children,
  ...props
}: LinkButtonProps) {
  return (
    <RACLink
      {...props}
      className={composeRenderProps(className, (className, renderProps) =>
        button({
          ...renderProps,
          variant,
          flex,
          className,
        }),
      )}
    >
      <ButtonContent variant={variant}>{children}</ButtonContent>
    </RACLink>
  )
}

export const LinkButton = createLink(MyLinkButton)
